/**
 * Parse une saisie quota tokens : vide = illimité (null), entier ≥ 0.
 * Retourne undefined si la valeur n'est pas un entier valide.
 */
export function u3206ParseQuotaInput(value: string): number | null | undefined {
  const trimmed = value.trim();
  if (trimmed === '') {
    return null;
  }
  const parsed = Number(trimmed);
  if (!Number.isInteger(parsed) || parsed < 0) {
    return undefined;
  }
  return parsed;
}

export function u3206FormatQuotaInputValue(value: number | null | undefined): string {
  if (value == null) {
    return '';
  }
  return String(value);
}
